<script lang="ts">
	import SkeletonBlock from './SkeletonBlock.svelte';

	interface Props {
		label?: string;
		class?: string;
	}

	const {
		label = '',
		class: classes,
	}: Props = $props();
</script>

<div class="flex flex-col gap-1">
	<h3 class="m-0 text-sm" style="font-weight: normal">{label}</h3>
	<div
		class={['flex justify-between items-center h-11 p-2 bg-neutral-weakest rd-2 b-0.5 b-solid border-coloredneutral-weakest', classes]}
	>
		<SkeletonBlock height="16px" width="60px" />
	</div>
</div>
